/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable no-await-in-loop */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable camelcase */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useMediaQuery } from "beautiful-react-hooks";
import { connect, useDispatch } from "react-redux";
import { Trans, t } from "@lingui/macro";
import get from "lodash/get";
import * as types from "../../stores/types";
import { isMobileUserAgent, getUserAgent } from "../../functions/userAgent";
import { fetchDefaultCurrency } from "../../functions/currency";
import { sendListViewedEvent } from "../../functions/analytics";
import { fetchOverview } from "../../functions/fetchData";
import reverseUrl from "../../functions/reverseUrl";
import getCurrentLanguage from "../../functions/languages/getCurrentLanguage";
import useCurrentLanguage from "../../functions/languages/useCurrentLanguage";
import withRedirectToKnownLang from "../../functions/languages/withRedirectToKnownLang";
import Root from "../../components/_Root";
import { isSSR } from "../../components/NoSSR";
import ScrollHook from "../../components/ScrollHook";
import { CanonicalAuto } from "../../components/Canonical";
import ProductsGrid from "../../components/ProductsGrid";
import { CustomerReviews } from "../../components/Reviews";
import AuthorBio from "../../components/AuthorBio";
import MTSHeader from "../../components/MTSHeader";
import { Api } from "../../functions/fetchFromApi";
import { AlternateAuto } from "../../components/Alternate";
import "./AuthorPage.css";
import Popup from "../../components/Popup";
import Button from "../../components/Button";
import { Icon } from "../../components/Icon";
import { RatingCount } from "../../components/Rating";
import useOnScreen from "../../functions/customHooks/useOnScreen";
import Spinner from "../../components/Spinner";
import { convertAuthorReviews } from "../../functions/convertAuthorReviews";
import ProductsGridAdapter from "../../components/ProductsGrid/ProductsGridAdapter";

const fetchAuthorReviews =
  author =>
  ({ dispatch, reviewsNumber, replaceStore, lang }) =>
  page =>
    dispatch({
      type: types.FETCH_AUTHOR_REVIEWS,
      page,
      author,
      replace: replaceStore,
      per_page: reviewsNumber,
      lang,
    });

// TODO: use hooks for redux
function Author({ mobile, nickname, author, products = {}, destinations, productsPerPage }) {
  const lang = useCurrentLanguage();
  const dispatch = useDispatch();
  const { categoryId, attractionId } = useParams();
  const isMobile = isSSR ? mobile : useMediaQuery("(max-width: 767px)");
  const productListId = `author_${nickname}`;
  const onProductListShown = () => {
    sendListViewedEvent(productListId, products.products, lang);
  };
  const history = useHistory();
  const isMTS = nickname === "mts";

  // Handles back navigation or redirects to the main page
  const handleButtonClick = useCallback(() => {
    const reverseCityUrl = reverseUrl("main", { lang });
    const currentPathName = history.location.pathname;
    const previousPage = localStorage.getItem("previousPage");
    const isNewPage = previousPage && previousPage !== currentPathName;

    history.push(isNewPage ? previousPage : reverseCityUrl);
  }, [lang, history]);

  const defaultProductsGridProps = {
    className: "AuthorPage__products",
    selectParams: { author: nickname, categoryId, attractionId, lang: null },
    listId: productListId,
    perPage: productsPerPage,
    showMoreButton: !isMobile,
    ...products,
  };

  const endOfProducts = useRef(null);
  const isEndOfProducts = useOnScreen(endOfProducts);

  useEffect(() => {
    if (isMobile && isEndOfProducts && products.next) {
      dispatch({
        type: types.FETCH_PRODUCTS,
        page: products.next,
        append: true,
        perPage: productsPerPage,
        author: nickname,
      });
    }
  }, [dispatch, isEndOfProducts, isMobile, nickname, products.next, productsPerPage]);

  return !isSSR ? (
    <Root
      stickyHeader
      searchInHeader
      redirectToLocalized
      footer={false}
      destinations={destinations}
      title={
        isMTS ? t`Urban Legends — MTS and WeGoTrip` : t`All tours and tickets by ${author.name}`
      }
      description={
        isMTS
          ? t`Free self-guided tours in cities of Russia created by locals`
          : t`Discover the best audio tours and tickets by ${author.name}. Compare tour, read reviews, and instantly book tours with tickets.`
      }
    >
      <AlternateAuto route="author-localized" />
      <CanonicalAuto route="author-localized" />

      {isMobile && (
        <Button
          className="AuthorPage__button"
          theme="touch"
          icon={<Icon name="arrow/left" />}
          aria-label={lang === "ru" ? "Вернуться назад" : "Go back"}
          onClick={handleButtonClick}
        />
      )}

      {isMTS ? (
        <div className="m-48">
          <MTSHeader />
        </div>
      ) : null}

      <div className="AuthorPage">
        <AuthorBio theme="card" {...author} products={products} />

        <ScrollHook once="shown" showOn=".AuthorPage__products" onChanged={onProductListShown} />

        <div className="AuthorPage__products-container">
          {!!products.products?.length && (
            <ProductsGrid
              {...defaultProductsGridProps}
              title={<Trans> The host's activities</Trans>}
              products={isMobile ? products.products.slice(0, productsPerPage) : products.products}
            />
          )}

          {isMobile && products.count > productsPerPage && (
            <Popup
              rendered
              title={<Trans> The host's activities</Trans>}
              theme="bottomSheet"
              triggerElement={
                <Button size="L" theme="card" onClick={() => {}}>
                  <Trans>Show more</Trans>
                </Button>
              }
            >
              <ProductsGrid {...defaultProductsGridProps} />
              <div ref={endOfProducts} className="AuthorPage__popupEnd">
                {products.next && <Spinner />}
              </div>
            </Popup>
          )}
          {author.reviews_count > 0 && (
            <CustomerReviews
              convertReviewFn={convertAuthorReviews}
              className="AuthorPage__reviews"
              lineHeight={15}
              lang={lang}
              isMobile={isMobile}
              withPopup={isMobile}
              popupTheme="bottomSheet"
              fetchFunction={fetchAuthorReviews(author.nickname)}
              title={
                <RatingCount
                  className="AuthorPage__reviews_count"
                  count={author.reviews_count}
                  countType="large"
                  size="large"
                />
              }
            />
          )}
        </div>
      </div>
    </Root>
  ) : null;
}

Author.getInitialProps = withRedirectToKnownLang(
  // eslint-disable-next-line no-unused-vars
  async ({ req, res, match, history, location, store, scrollToTop, page = 1, ...selectParams }) => {
    try {
      const cookies = get(req, "headers.cookie");
      const mobile = isMobileUserAgent(getUserAgent(req));
      store.dispatch({ type: types.FETCH_USER, cookies });

      const currency = await fetchDefaultCurrency(req);
      store.dispatch({ type: types.SET_DEFAULT_CURRENCY, defaultCurrency: currency });

      const lang = getCurrentLanguage(match.params.lang);
      const { nickname } = match.params;
      let result = {};

      store.dispatch({ type: types.FETCH_LANGUAGES });

      const productsPerPage = mobile ? 4 : 6;
      store.dispatch({
        type: types.FETCH_PRODUCTS,
        perPage: productsPerPage,
        author: nickname,
      });

      const overview = await fetchOverview({ lang }, req);
      store.dispatch({ type: types.SET_OVERVIEW, data: overview });

      let author = {};
      try {
        const { data } = await Api.get(`/api/v2/authors/${nickname}/`, {
          lang,
        });
        author = data;
      } catch (e) {
        console.error(e);
      }

      const {
        reviews: { count: reviewsCount },
      } = store.getState();

      if (!reviewsCount) {
        store.dispatch({
          type: types.FETCH_AUTHOR_REVIEWS,
          lang,
          author: nickname,
          per_page: mobile ? 3 : 6,
        });
      }

      /**
       * Redirecting to main page if no tours presented
       * Runs only if `bubbling` query param is set
       */
      if (req && get(req, "query.bubbling")) {
        return {
          redirectTo: reverseUrl("main", {
            lang,
          }),
        };
      }

      if (Object.keys(author).length === 0) {
        return {
          redirectTo: reverseUrl("error", {
            lang,
          }),
        };
      }

      // Disable autoscroll to top for category picking
      // eslint-disable-next-line no-param-reassign
      scrollToTop.current = false;

      result = {
        nickname,
        author,
        scrollToTop,
        ...result,
        destinations: overview.topCities,
        mobile,
        productsPerPage,
      };

      return result;
    } catch (error) {
      // TODO: serve 500 for not 404 errors
      return { statusCode: 404 };
    }
  },
);

const mapStateToProps = ({ products, user, reviews }) => ({
  products,
  user,
  reviews,
});

export default connect(mapStateToProps)(Author);
